<template>
  <div class="mt-3 mb-3 d-flex justify-content-start align-items-center no-print gap-2">
    <b-button variant="warning" @click="voltar()">
      <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Voltar
    </b-button>

    <div v-if="viewMode === 'tabela'">
      <b-button v-if="!disableGeracaoPdf" class="btn-blue-custom" @click="$emit('gerar-pdf')">
        <i :class="fluxoInterno ? 'fa fa-upload mr-2' : 'fa fa-print mr-2'"></i>
        {{ textoBotaoGerarPdf }}
      </b-button>
    </div>

    <div v-if="viewMode === 'pdf-viewer'" class="d-flex gap-2">
      <b-button class="btn-blue-custom" @click="$emit('baixar-pdf')">
        <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 9V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V9M3.66667 5.66667L7 9M7 9L10.3333 5.66667M7 9V1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Baixar PDF
      </b-button>

      <b-button class="btn-green-custom" @click="$emit('proxima-etapa')">
        <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.00016 10.7803L3.2135 7.99365L2.27283 8.93432L6.00016 12.6617L14.0002 4.66165L13.0595 3.72098L6.00016 10.7803Z" fill="white"/>
        </svg>
        Próxima Etapa
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CurvaSAcoesBtn',
  props: {
    viewMode: {
      type: String,
      required: true,
      default: 'tabela'
    },
    disableEnviar: {
      type: Boolean,
      default: false
    },
    disableGeracaoPdf: {
      type: Boolean,
      default: false
    },
    textoBotaoGerarPdf: {
      type: String,
      default: 'Gerar PDF para Assinatura'
    },
    fluxoInterno: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    voltar() {
      this.$emit('voltar');
    }
  }
};
</script>

<style scoped>
.btn-blue-custom {
  background-color: #2E60AD !important;
  border-color: #2E60AD !important;
  color: #fff !important;
}

.btn-blue-custom:hover {
  filter: brightness(0.9);
}

.btn-green-custom {
  background-color: #23A26D !important;
  border-color: #23A26D !important;
  color: #fff !important;
}

.btn-green-custom:hover {
  filter: brightness(0.9);
}

.gap-2 {
  gap: 8px;
}

@media print {
  .no-print {
    display: none !important;
  }
}
</style>
